import { gql } from 'graphql-request'

export const GET_TOTAL_USER_MANAGEMENTS = gql`
  query GetUserManagementTableCount(
    $searchText: String!
    $isIncludePenName: Boolean
  ) {
    getUserManagementTableCount(
      searchText: $searchText
      isIncludePenName: $isIncludePenName
    ) {
      allCount
      publisherCount
      writerCount
      readerCount
      banCount
    }
  }
`
